<template>
  <div class="gift_show">
    <div class="swiperLottery">
      <div class="swiper-wrapper" ref="slides" @touchmove="touchAction">
        <div class="swiper-slide" v-for="(item, index) in state.lotteryList">
          <img :src="item.url" alt="" />
        </div>
      </div>
    </div>
    <p>您还有 {{ state.lotteryCount }} 次抽奖机会</p>
    <div class="lotteryBtn">
      <img
        src="../../../assets/webActivity/homeTwoGame/icon_lottery.png"
        alt=""
        @click="startLottery"
        v-if="state.lotteryCount > 0"
      />
      <img
        src="../../../assets/webActivity/homeTwoGame/icon_lottery_no.png"
        alt=""
        v-else
      />
    </div>
  </div>

  <div class="gift_lottery">
    <van-popup v-model:show="state.popShow" @close="popshowClose">
      <div class="popContent">
        <div class="card" ref="giftCard">
          <img
            src="../../../assets/webActivity/homeTwoGame/icon_lottery_card.png"
            alt=""
            @click="showGift"
          />
          <img :src="state.myPrize" alt="" />
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script setup>
import "swiper/swiper-bundle.min.js";
import { Swiper, Pagination, Autoplay } from "swiper";
import { onMounted, ref, reactive, nextTick, watch } from "vue";
import "swiper/modules/effect-creative/effect-creative.min.css";
import { getactivityDraw, getactivityInfo } from "@/api/activity";
import { detect } from "@/utils/device";
import { Toast } from "vant";

const state = reactive({
  popShow: false,
  lotteryCount: 0,
  lotteryList: [
    {
      id: 0,
      name: "0.2余额",
      url: require("../../../assets/webActivity/homeTwoGame/lotteryInfo/zeroTwo.png"),
    },
    {
      id: 1,
      name: "0.3余额",
      url: require("../../../assets/webActivity/homeTwoGame/lotteryInfo/zeroThree.png"),
    },
    {
      id: 2,
      name: "0.5余额",
      url: require("../../../assets/webActivity/homeTwoGame/lotteryInfo/zeroFive.png"),
    },
    {
      id: 3,
      name: "0.8余额",
      url: require("../../../assets/webActivity/homeTwoGame/lotteryInfo/zeroEight.png"),
    },
    {
      id: 4,
      name: "1余额",
      url: require("../../../assets/webActivity/homeTwoGame/lotteryInfo/one.png"),
    },
    {
      id: 5,
      name: "98元优惠券",
      url: require("../../../assets/webActivity/homeTwoGame/lotteryInfo/98coupon.png"),
    },
    {
      id: 6,
      name: "198元优惠券",
      url: require("../../../assets/webActivity/homeTwoGame/lotteryInfo/198coupon.png"),
    },
    {
      id: 7,
      name: "648元优惠券",
      url: require("../../../assets/webActivity/homeTwoGame/lotteryInfo/648coupon.png"),
    },
  ],

  myPrize: "",
});

const props = defineProps({
  lotteryNum: {
    type: Number,
    default: 0,
  },
  token: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["getActivity"]);
watch(
  () => props.lotteryNum,
  (newVal, oldVal) => {
    // console.log("抽奖次数newVal", newVal);
    state.lotteryCount = newVal;
  }
);

// 第二个轮播图
// const openpopoUp = () => {
//   state.popShow = true;
//   console.log("state.popShow", state.popShow);
// };

let giftCard = ref(null);
const showGift = () => {
  // 添加css动画，翻转180deg
  giftCard.value.style.transform = "rotateY(180deg)";
  giftCard.value.style.transition = "transform 1.5s";
};
const popshowClose = () => {
  giftCard.value.style.transform = "rotateY(0deg)";
};

onMounted(() => {
  nextTick(() => {
    initSwiper();
  });
});
var mySwiper = "";
var slides = ref(null);

Swiper.use([Pagination, Autoplay]);
const initSwiper = () => {
  mySwiper = new Swiper(".swiperLottery", {
    autoplay: {
      disableOnInteraction: false,
    },
    loop: true,
    centeredSlides: true,
    slidesPerView: 2.5,
    spaceBetween: 10,
    observer: true, //修改swiper自己或子元素时，自动初始化swiper
    observeParents: true, //修改swiper的父元素时，自动初始化swiper
    onSlideChangeEnd: function(swiper) {
      swiper.update();
      mySwiper.startAutoplay();
      mySwiper.reLoop();
    },
  });
};

// 抽奖阻断按钮
var startFlag = false;
const startLottery = async () => {
  // console.log("获取本地存的token-----", props.token);

  if (startFlag) return;
  startFlag = true;
  // 抽奖开始
  let res = await getactivityDraw({
    token: props.token,
  });
  startFlag = false;
  if (res.data.code == "1") {
    // 更新抽奖次数
    if (state.lotteryCount > 0) {
      state.lotteryCount--;
    }
    // 挑选0-3
    // let num = Math.floor(Math.random() * 4);
    state.popShow = true;
    state.lotteryList.filter((item) => {
      if (item.id == res.data.data.pnum) {
        state.myPrize = item.url;
      }
    });
  } else {
    Toast.fail(res.data.msg);
  }
  emit("getActivity");
};

// 触摸事件
const touchAction = (e) => {
  if (detect() == "android" || detect() == "harmony") {
    // window.document.location = "disPatchTouchViewPager://" + true;

    window.JsBridge.disPatchTouchViewPager(true);
  }
};
</script>
<style scoped>
.gift_show {
  height: 1000px;
  width: 100vw;
  background-image: url(../../../assets/webActivity/homeTwoGame/test2.png);
  background-size: 100% 100%;
  overflow: hidden;
  padding-top: 250px;
}
.gift_show p {
  width: 100%;
  text-align: center;
  color: #fff;
  margin-top: -15px;
}
/* .gift_show {
  margin-top: -15px;
} */
.gift_show .lotteryBtn {
  width: 100%;
  margin-top: 32px;
  display: flex;
  justify-content: center;
}
.gift_show .lotteryBtn img {
  width: 352px;
  height: 160px;
}
/* 弹出层 */
:deep(.van-popup) {
  background: none;
}
:deep(.van-overlay) {
  background-color: rgba(0, 0, 0, 0.6);
}
.popContent {
  height: 624px;
  width: 416px;
}
.popContent .card {
  position: relative;
  width: 100%;
  height: 100%;
  /* 设置为3d盒子 */
  transform-style: preserve-3d;
  perspective: 1000px;
}
.card img {
  position: absolute;
  /* 设置背部不可见 */
  backface-visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.card img:nth-of-type(2) {
  transform: rotateY(180deg);
}

.swiperLottery {
  /* width: 500px; */
  height: 500px;
  touch-action: pan-y pinch-zoom;
}
.swiperLottery .swiper-wrapper {
  height: 400px;
  padding-top: 10px;
}
.swiperLottery div div {
  width: 100%;
  height: 430px;
  border-radius: 20px;
}
.swiper-slide-active {
  color: #fff;
}

.swiper-container {
  width: 100%;
  height: 100%;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: 300ms;
  transform: scale(0.9);
}
.swiper-slide img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1.15);
}
</style>
